import React, { FC } from "react";

import { ButtonContainer } from "./navigation-button.styles";
import { IconProps } from "utils/interfaces";
import { useTranslation } from "react-i18next";
import { primaryColor } from "utils/form-constants";

interface Props {
  buttonText: string;
  Icon: FC<IconProps>;
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  isActive: boolean;
  disabled?: boolean;
}

const NavigationButton: React.FC<Props> = ({
  buttonText,
  Icon,
  onClick,
  isActive,
  disabled,
}) => {
  const { t } = useTranslation();

  return (
    <ButtonContainer
      isCurrentOrPastForm={isActive}
      onClick={onClick}
      data-cy={buttonText}
      disabled={disabled}
    >
      <Icon color={isActive ? primaryColor : "#000"} />
      <span>{t(buttonText)}</span>
    </ButtonContainer>
  );
};

export default NavigationButton;
